function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransportationCarFrontRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 23h6v-3h-6v3zm-5.5-3a1.5 1.5 0 11.001-3.001A1.5 1.5 0 017.5 20zm.169-15h16.662l1.273 7H6.396l1.273-7zM26 18.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 0126 18.5zm3.664-4.004l-1.07-1.605a1.992 1.992 0 00-.929-.735l-1.366-7.513A2 2 0 0024.331 3H7.669a2 2 0 00-1.968 1.643l-1.366 7.513c-.371.148-.7.393-.929.735l-1.07 1.605A2 2 0 002 15.605V23a2 2 0 002 2v2a2 2 0 002 2h1a2 2 0 002-2v-2h14v2a2 2 0 002 2h1a2 2 0 002-2v-2a2 2 0 002-2v-7.395a2 2 0 00-.336-1.109z",
    fill: props.color
  }));
}

export default SvgIconTransportationCarFrontRexFilled;